const awsconfig = {
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: 'ap-southeast-2_lqAN0pAbt',
    userPoolWebClientId: '75uiukgtoguam6ge5hppdh2i4g',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  API: {
    endpoints: [
      {
        name: 'EversetAPI',
        endpoint: 'https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod',
        region: 'ap-southeast-2'
      }
    ]
  }
};

export default awsconfig;
